import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider, useTheme } from "@/context/ThemeContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppProvider } from "@/context/AppContext";
import Layout from "@/components/Layout";
import { Loading } from "@/components/ui-helpers";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Trips from "@/pages/Trips";
import Products from "@/pages/Products";
import Orders from "@/pages/Orders";
import OrdersKanban from "@/pages/OrdersKanban";
import OrderConfirmation from "@/pages/OrderConfirmation";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import Payments from "@/pages/Payments";
import Invoices from "@/pages/Invoices";
import Purchases from "@/pages/Purchases";
import ShoppingList from "@/pages/ShoppingList";
import Deliveries from "@/pages/Deliveries";
import Expenses from "@/pages/Expenses";
import Reports from "@/pages/Reports";
import Analytics from "@/pages/Analytics";
import Catalogue from "@/pages/Catalogue";
import Settings from "@/pages/Settings";
import RecycleBin from "@/pages/RecycleBin";
import PublicCatalogue from "@/pages/PublicCatalogue";

function Protected({ children, adminOnly }) {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !isAdmin) {
    return (
      <AppProvider>
        <Layout><Navigate to="/" replace /></Layout>
      </AppProvider>
    );
  }
  return (
    <AppProvider>
      <Layout>{children}</Layout>
    </AppProvider>
  );
}

function ThemedToaster() {
  const { resolved } = useTheme();
  return <Toaster position="top-right" richColors theme={resolved} />;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/katalog/:tripId" element={<PublicCatalogue />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/trips" element={<Protected><Trips /></Protected>} />
            <Route path="/products" element={<Protected><Products /></Protected>} />
            <Route path="/orders" element={<Protected><Orders /></Protected>} />
            <Route path="/orders/confirm" element={<Protected><OrderConfirmation /></Protected>} />
            <Route path="/orders/kanban" element={<Protected><OrdersKanban /></Protected>} />
            <Route path="/customers" element={<Protected><Customers /></Protected>} />
            <Route path="/customers/:cid" element={<Protected><CustomerDetail /></Protected>} />
            <Route path="/payments" element={<Protected><Payments /></Protected>} />
            <Route path="/invoices" element={<Protected><Invoices /></Protected>} />
            <Route path="/purchases" element={<Protected><Purchases /></Protected>} />
            <Route path="/shopping-list" element={<Protected><ShoppingList /></Protected>} />
            <Route path="/deliveries" element={<Protected><Deliveries /></Protected>} />
            <Route path="/expenses" element={<Protected><Expenses /></Protected>} />
            <Route path="/reports" element={<Protected><Reports /></Protected>} />
            <Route path="/analytics" element={<Protected><Analytics /></Protected>} />
            <Route path="/catalogue" element={<Protected><Catalogue /></Protected>} />
            <Route path="/settings" element={<Protected adminOnly><Settings /></Protected>} />
            <Route path="/recycle-bin" element={<Protected adminOnly><RecycleBin /></Protected>} />
          </Routes>
          <ThemedToaster />
        </AuthProvider>
      </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
